import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import animeConfig from '../config/animeConfig';
import './Guides.css';

// Character data verified via Jikan API (api.jikan.moe/v4/characters?q=...)
const fruits = [
  {
    name: 'Gomu Gomu no Mi',
    type: 'Paramecia / Mythical Zoan (revealed)',
    user: 'Monkey D. Luffy',
    image: 'https://cdn.myanimelist.net/images/characters/9/310307.jpg',
    bio: "Turns the eater into a rubber human — punches stretch, bullets bounce off, and blunt attacks do almost nothing. The World Government hid its real name for over 800 years. It is actually the Hito Hito no Mi, Model: Nika, a Mythical Zoan that awakens into the form of the Sun God. Luffy unlocked this awakening (Gear Fifth) during his rooftop fight with Kaido in Wano, gaining the power to turn everything around him rubbery — including the ground, lightning, and people."
  },
  {
    name: 'Mera Mera no Mi',
    type: 'Logia (fire)',
    user: 'Portgas D. Ace, then Sabo',
    image: 'https://cdn.myanimelist.net/images/characters/2/72220.jpg',
    bio: "The Flame-Flame Fruit. Lets the user create, control, and become fire. Portgas D. Ace — the only son of Gol D. Roger and Luffy's adopted older brother — wielded it as the Second Division Commander of the Whitebeard Pirates. After Ace died at Marineford, the fruit reappeared and Sabo won it at the Corrida Colosseum tournament in Dressrosa, inheriting his brother's fire."
  },
  {
    name: 'Ope Ope no Mi',
    type: 'Paramecia',
    user: 'Trafalgar D. Water Law',
    image: 'https://cdn.myanimelist.net/images/characters/10/258757.jpg',
    bio: "The OP-Op Fruit. Creates a spherical space called Room where Law can cut, rearrange, swap, and teleport anything inside — people, objects, terrain. He can remove hearts without killing, attach severed limbs to other bodies, and scan for anything hidden. The fruit can also perform the Perennial Youth Operation, granting someone eternal youth at the cost of the user's life. The World Government considers it the most valuable Devil Fruit in existence. Law's bounty after Wano is 3,000,000,000 berries."
  },
  {
    name: 'Hie Hie no Mi',
    type: 'Logia (ice)',
    user: 'Kuzan (Aokiji)',
    image: 'https://cdn.myanimelist.net/images/characters/9/96167.jpg',
    bio: "The Ice-Ice Fruit. Turns the user into a Freezing Man who can create and become ice. Kuzan, formerly known as Admiral Aokiji, could freeze entire oceans and battlefields in seconds. He shares a history with Nico Robin — he was a friend of Vice Admiral Jaguar D. Saul, who saved Robin as a child. After losing his admiralty to Akainu in a 10-day fight on Punk Hazard, Kuzan left the Marines. He is currently allied with the Blackbeard Pirates for unknown reasons."
  },
  {
    name: 'Magu Magu no Mi',
    type: 'Logia (magma)',
    user: 'Sakazuki (Akainu)',
    image: 'https://cdn.myanimelist.net/images/characters/16/306908.jpg',
    bio: "The Magma-Magma Fruit. Magma burns hotter than fire, which is how Akainu's fist punched through Ace's fire body and killed him at Marineford — a Logia killing another Logia. Sakazuki went on to become Fleet Admiral after defeating Aokiji in a 10-day duel that permanently changed the climate of Punk Hazard — one half frozen, the other half volcanic."
  },
  {
    name: 'Pika Pika no Mi',
    type: 'Logia (light)',
    user: 'Borsalino (Kizaru)',
    image: 'https://cdn.myanimelist.net/images/characters/12/96168.jpg',
    bio: "The Glint-Glint Fruit. Lets the user move and attack at the speed of light. Admiral Kizaru can fire laser beams from his fingertips, travel as a beam of light, and form a sword out of light itself. Despite having arguably the most overpowered ability in the series, he fights with a relaxed, almost lazy attitude."
  },
  {
    name: 'Yami Yami no Mi',
    type: 'Logia (darkness)',
    user: 'Marshall D. Teach (Blackbeard)',
    image: 'https://cdn.myanimelist.net/images/characters/2/109536.jpg',
    bio: "The Dark-Dark Fruit. The only Logia that does not let the user dodge attacks by turning intangible — instead, it pulls everything in like a black hole, including pain. Its real power is canceling other Devil Fruit abilities on contact. Blackbeard murdered his own crewmate, Thatch of the Whitebeard Pirates, specifically to steal this fruit. He spent decades on Whitebeard's ship waiting for it to appear."
  },
  {
    name: 'Gura Gura no Mi',
    type: 'Paramecia',
    user: 'Edward Newgate (Whitebeard), then Blackbeard',
    image: 'https://cdn.myanimelist.net/images/characters/3/100236.jpg',
    bio: "The Tremor-Tremor Fruit. Creates earthquakes and shockwaves strong enough to destroy the world. Whitebeard cracked the air itself and split Marineford's plaza in two while dying. After Whitebeard fell, Blackbeard somehow stole this power from his corpse — becoming the first and only known person in history to wield two Devil Fruits at once. Nobody knows how he did it."
  },
  {
    name: 'Hana Hana no Mi',
    type: 'Paramecia',
    user: 'Nico Robin',
    image: 'https://cdn.myanimelist.net/images/characters/16/363700.jpg',
    bio: "The Flower-Flower Fruit (also called the Bloom-Bloom Fruit). Lets the user sprout copies of their own body parts on any surface — walls, the ground, other people's bodies. Robin was once an officer of Crocodile's Baroque Works under the name Miss All Sunday. After the timeskip she can create full-body duplicates and even giant limbs. Her bounty of 930,000,000 berries reflects the World Government's fear of her ability to read Poneglyphs."
  },
  {
    name: 'Suna Suna no Mi',
    type: 'Logia (sand)',
    user: 'Sir Crocodile',
    image: 'https://cdn.myanimelist.net/images/characters/6/100535.jpg',
    bio: "The Sand-Sand Fruit. Turns the user into sand and lets them drain moisture from anything they touch — people, the ground, entire cities. Crocodile was the mastermind behind Baroque Works, where he operated as Mr. 0 with Nico Robin as his partner. A former Warlord who nearly took over Alabasta. The long scar across his face came from a fight with Whitebeard. Now part of Cross Guild alongside Mihawk and Buggy."
  }
];

const GuideDevilFruits = () => {
  const bgStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.85)), url(${animeConfig.onePiece.backgroundImage})`,
  };

  return (
    <>
      <Helmet>
        <title>Devil Fruits Explained - Types, Powers and Who Eats Them</title>
        <meta name="description" content="The three types of Devil Fruit in One Piece - Paramecia, Zoan, and Logia. Key fruits, their users, and what each one does. A short fan guide." />
        <link rel="canonical" href="https://www.onepiecetrivia.com/guides/devil-fruits" />
        <meta property="og:title" content="Devil Fruits Explained - Types, Powers and Who Eats Them" />
        <meta property="og:description" content="The three types of Devil Fruit, their most famous users, and what makes each one dangerous." />
        <meta property="og:url" content="https://www.onepiecetrivia.com/guides/devil-fruits" />
      </Helmet>

      <div className="guide-page-wrapper" style={bgStyle}>
        <div className="guide-container">
          <h1>Devil Fruits Explained</h1>
          <p className="guide-intro">
            Devil Fruits give the eater a power, but cost them the ability to swim. Here's how they work and the key fruits you need to know.
          </p>

          <h2>The Three Types</h2>

          <div className="guide-entry">
            <h3>Paramecia</h3>
            <p>
              The most common type. Gives the user a power that alters their body, their surroundings, or a specific object. Luffy's rubber body, Robin's limb sprouting, and Law's Room are all Paramecia.
            </p>
          </div>

          <div className="guide-entry">
            <h3>Zoan</h3>
            <p>
              Lets the user transform into an animal and a hybrid form. Chopper is the obvious example. There are also Mythical Zoans (phoenixes, dragons, gods) which are far rarer and stronger - Marco, Sengoku, and Yamato all have Mythical Zoans.
            </p>
          </div>

          <div className="guide-entry">
            <h3>Logia</h3>
            <p>
              The rarest type. Turns the user's body into an element - fire, ice, smoke, magma, light, darkness. Most physical attacks pass through them. Haki is the main way to land hits on a Logia user.
            </p>
          </div>

          <h2>Key Fruits and Their Users</h2>

          {fruits.map((fruit) => (
            <div className="guide-entry guide-entry-with-image" key={fruit.name}>
              <img
                src={fruit.image}
                alt={`${fruit.user} from One Piece`}
                className="guide-entry-image"
                loading="lazy"
              />
              <div className="guide-entry-body">
                <h3>{fruit.name} - {fruit.user}</h3>
                <div className="entry-meta">{fruit.type}</div>
                <p>{fruit.bio}</p>
              </div>
            </div>
          ))}

          <div className="guide-cta">
            <h2>Ready to test what you read?</h2>
            <p>Play the Devil Fruit Quiz and name the fruits from the anime.</p>
            <Link to="/devil-fruit-quiz" className="guide-cta-button">Play the Devil Fruit Quiz</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuideDevilFruits;
